import React from "react"
import Block from "@bappweb/block"
import { useAppSelector } from "../../../config/hook"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import "../../assets/style.scss"
import { getConfigValue } from "@smpu-web/utils/utils"

const Notes = () => {
    const sessionData = useAppSelector((state) => state.sessionData.response)

    return (
        <Block type="section" className="notes-page-wrapper" id="landing-page-wrapper">
            <Block type="section" className="section general-features" dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "CreditCard.LandingStudent.CampaignText.Top") }} />
            <Block type="section" className="section general-features" dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "CreditCard.LandingStudent.CampaignText.Middle") }} />
        </Block>
    )
}

export default Notes
